import { HttpHeaders } from '@angular/common/http';

/**
 * Session values from localStorage must be read when used, not cached on Angular singletons
 * (providedIn: 'root' services live for the app lifetime; login / account switch updates storage only).
 */

export function getStoredUserId(): string | null {
  if (typeof localStorage === 'undefined') {
    return null;
  }
  return localStorage.getItem('user_id');
}

export function getStoredAuthToken(): string | null {
  if (typeof localStorage === 'undefined') {
    return null;
  }
  const t = localStorage.getItem('token');
  return t && t.trim() !== '' ? t : null;
}

/** JSON POSTs: Content-Type + Bearer when a token exists. */
export function buildAuthJsonHeaders(): HttpHeaders {
  const token = getStoredAuthToken();
  return new HttpHeaders({
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  });
}

/** FormData, or requests that must not force application/json. Bearer only when token exists. */
export function buildAuthBearerHeaders(): HttpHeaders {
  const token = getStoredAuthToken();
  return new HttpHeaders(token ? { Authorization: `Bearer ${token}` } : {});
}
